import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-2xl font-bold font-heading text-background-50 hover:text-primary-400 transition-colors">
              91社区
            </Link>
            <p className="mt-3 text-background-400 text-sm leading-relaxed">
              国内人气超高的综合性内容平台，汇聚海量优质资源与活跃用户群体，提供流畅浏览体验与多元化内容分类。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" aria-label="微信" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" aria-label="微博" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" aria-label="B站" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-background-400 hover:text-primary-400 text-sm transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-background-400 hover:text-primary-400 text-sm transition-colors">首页</Link>
              <Link to="/about" className="text-background-400 hover:text-primary-400 text-sm transition-colors">关于我们</Link>
              <Link to="/about" className="text-background-400 hover:text-primary-400 text-sm transition-colors">加入社区</Link>
              <Link to="/about" className="text-background-400 hover:text-primary-400 text-sm transition-colors">联系我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <p>邮箱：support@91shequ.com</p>
              <p>地址：北京市朝阳区互联网大厦</p>
              <p>工作时间：周一至周日 9:00-21:00</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; 2026 91社区 版权所有 | ICP备2024000000号
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}